import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-ohel-camp-pagamento-annullato',
  standalone: true,
  templateUrl: './pagamento-annullato.component.html',
  styleUrl: './pagamento-annullato.component.scss',
  imports: [CommonModule, RouterLink],
})
export class OhelCampPagamentoAnnullatoComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private meta = inject(Meta);
  private title = inject(Title);

  registrationId: string | null = null;

  ngOnInit() {
    this.title.setTitle('Pagamento Annullato - Ohel Camp 2026');

    this.meta.updateTag({
      name: 'robots',
      content: 'noindex, nofollow',
    });

    this.registrationId =
      this.route.snapshot.queryParamMap.get('registration_id');
  }
}
